import { render, staticRenderFns } from "./TrackerAlarmsForm.vue?vue&type=template&id=4096be0c"
import script from "./TrackerAlarmsForm.vue?vue&type=script&lang=js"
export * from "./TrackerAlarmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports